import { z } from 'zod';
import { isIsoDate } from './dates.js';
import { isValidMoney } from './money.js';

export const zUuid = z.string().uuid();
export const zIsoDate = z.string().refine(isIsoDate, { message: 'YYYY-MM-DD 形式で指定してください' });
export const zMoney = z
  .union([z.string(), z.number()])
  .refine(isValidMoney, { message: '金額の形式が不正です' })
  .transform((v) => String(v));
export const zNonEmpty = z.string().trim().min(1, '必須項目です');

export const zPagination = z.object({
  limit: z.coerce.number().int().min(1).max(200).default(50),
  cursor: z.string().optional(),
});
export type Pagination = z.infer<typeof zPagination>;

export interface Page<T> {
  items: T[];
  nextCursor: string | null;
}

/** 適格請求書発行事業者登録番号（T + 13 桁） */
export const zInvoiceRegistrationNumber = z
  .string()
  .regex(/^T\d{13}$/, '登録番号は T + 13 桁の数字です');

export function formatZodError(err: z.ZodError): Array<{ path: string; message: string }> {
  return err.issues.map((i) => ({ path: i.path.join('.'), message: i.message }));
}
